<template>
  <div id="navbar_pantalla" class="w3-container w3-row" v-if="isAuthenticated && currentSubmenuActions">
    <div id="navbar_pantalla_submenu" class="w3-row">
      <div :class="['navbar_pantalla_item', {'selected': isCurrentSubmenuSelected(item.parentContextPath + item.contextPath + '/') }]" v-for="item in currentSubmenu" :key="item.id">
        <!-- internal link -->
        <router-link v-if="item.contextPath"
          :to="{ path: item.parentContextPath + item.contextPath }"
        >
          <!--<i :class="['sherpa-icon', 'icon-'+item.id]"></i>-->
          <span> {{ item.name }} </span>
        </router-link>

        <!-- external link -->
        <a v-else-if="item.externalUrl"
          :href="item.externalUrl"
          target="_blank"
        >
          <!--<i :class="['sherpa-icon', 'icon-'+item.id]"></i>-->
          <span> {{ item.name }} </span>
        </a>
      </div>
    </div>
    <div id="navbar_pantalla_submenu_actions" class="w3-row">
      <div class="navbar_pantalla_item" v-for="item in currentSubmenuActions" :key="item.id">
        <div class="navbar_pantalla_item_inner">
          <!-- internal link -->
          <router-link v-if="item.contextPath"
            :to="{ path: item.parentContextPath + item.contextPath }"
            :class="{'link-active':isNewSectionInsideSearcher(item.id)}"
          >
            <div>
              <i :class="['sherpa-icon', 'icon-'+item.id]"></i>
              <span> {{ item.name }} </span>
            </div>
          </router-link>

          <!-- external link -->
          <a v-else-if="item.externalUrl"
            :href="item.externalUrl"
            target="_blank"
          >
            <div>
              <i :class="['sherpa-icon', 'icon-'+item.id]"></i>
              <span> {{ item.name }} </span>
            </div>
          </a>
        </div>
        <div v-if="isCurrentSubmenuSelected(item.parentContextPath + item.contextPath)" class="action-selected"></div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import * as authTypes from '@/store/actions/auth'
import * as appTypes from '@/store/actions/app'

export default {
  name: 'actions-header',
  data () {
    return {
      currentSubmenu: [],
      currentSubmenuActions: []
    }
  },
  methods: {
    isCurrentSubmenuSelected (subMenuPath) {
      return this.$route.path.indexOf(subMenuPath) === 0
    },
    isNewSectionInsideSearcher (menuId) {
      var result = false
      if (this.$route.name) {
        var searcherNameFromNew = 'search-' + this.$route.name.substr(this.$route.name.indexOf('new-') + 4)
        result = menuId === searcherNameFromNew
      }
      return result
    }
  },
  computed: {
    ...mapGetters(`${authTypes.AUTH_NAMESPACE}`, [`${authTypes.AUTH_AUTHENTICATED}`]),
    newCurrentSubmenu () {
      return getCurrentContentMenu(
        this.$store.getters[`${appTypes.APP_NAMESPACE}/${appTypes.APP_CURRENT_CONTENT_ID}`],
        this.$store.getters[`${appTypes.APP_NAMESPACE}/${appTypes.APP_CURRENT_MENU}`],
        null
      )
    }
  },
  watch: {
    newCurrentSubmenu (currentMenu) {
      if (currentMenu) {
        this.currentSubmenu = currentMenu.subMenu
        var newCurrentSubmenu = getCurrentContentMenu(this.$store.getters[`${appTypes.APP_NAMESPACE}/${appTypes.APP_CURRENT_CONTENT_ID}`], this.currentSubmenu, null)
        if (newCurrentSubmenu) {
          // limit for search options (new option will be inside the searcher container)
          if (newCurrentSubmenu.subMenu) {
            this.currentSubmenuActions = []
            newCurrentSubmenu.subMenu.map((submenu) => {
              if (submenu.type && (submenu.type.id === 'search' || submenu.type.id === 'tree' || (submenu.type.id === 'definition' && submenu.type.modeView === 'modify'))) {
                this.currentSubmenuActions.push(submenu)
              }
            })
          } else {
            this.currentSubmenuActions = null
          }
        } else {
          this.currentSubmenuActions = null
        }
      }
    }
  }
}

function getCurrentContentMenu (currentContentId, menu, parentMenu) {
  var currentMenu = null
  if (menu) {
    menu.map((item) => {
      if (item.id === currentContentId) {
        if (parentMenu === null) {
          currentMenu = item
        } else {
          currentMenu = parentMenu
        }
      }
      if (item.subMenu) {
        var childCurrentMenu = getCurrentContentMenu(currentContentId, item.subMenu, item)
        if (childCurrentMenu) {
          if (parentMenu === null) {
            currentMenu = childCurrentMenu
          } else {
            currentMenu = parentMenu
          }
        }
      }
    })
  }
  return currentMenu
}
</script>

<style lang="scss">
#content #navbar_pantalla {
  width: 100%;
  margin: 0;
  padding: 9px 0 0;
  transition: all 0.3s ease-in;

  #navbar_pantalla_submenu {
    display: flex;
    flex-flow: wrap;
    background-color: #fff;

    .navbar_pantalla_item {
      position: relative;
      height: 100%;
      margin: 0;
      padding: 2px 10px 8px 9px;

      &.selected {
        background-color: #fff;
      }

      a {
        width: 100%;
        height: 100%;
        text-align: center;
        text-decoration: none;
        font-family: "Source Sans Pro", sans-serif;
        font-size: 20px;
        font-weight: 600;
        padding-bottom: 3px;

        i {
          position: absolute;
          top: 24%;
          left: 31%;
          font-size: 24px;
          color: #000;
        }
      }

      a.link-active,
      a:hover {
        box-shadow: 0px -5px 0px #d42e12 inset;
        transition: box-shadow 0.2s ease-in;
      }
    }
  }

  #navbar_pantalla_submenu_actions {
    position: relative;
    height: 100%;
    display: flex;
    flex-flow: wrap;
    background-color: #fff;

    .navbar_pantalla_item {
      cursor: pointer;
      padding: 0 5px 9px 10px;
      position: relative;

      .navbar_pantalla_item_inner {
        height: 100%;
        width: 100%;

        a {
          text-decoration: none;
          width: 100%;
          height: 100%;
          display: block;

          >div {
            padding: 8px 0 0;

            span {
              font-family: "Source Sans Pro", sans-serif;
              font-size: 16px;
              font-weight: 600;
              font-style: normal;
              font-stretch: normal;
              line-height: normal;
              letter-spacing: normal;
              text-align: right;
              color: #666;
            }

            i {
              font-size: 11px;
              margin-right: 0px;
              vertical-align: middle;
              color: #d42e12;
              display: none;
            }
          }
        }

        a.link-active,
        a:hover {
          span,
          i {
            transition: all 0.2s ease-in;
            box-shadow: 0px -2px 0px #d42e12 inset;
          }
        }
      }
    }

    .action-selected {
      position: absolute;
      height: 1px;
      background-color: #fff;
      bottom: 0;
      left: 0;
      right: 0;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/appHeader/actionsHeader.vue